import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowUpRight, ChevronRight } from 'lucide-react';
import { useRemote } from './api';
import { useApp } from './context';
import { LinkButton, LoadState } from './ui';
import { ProductInfo, ProductMedia, ProductSpecifications } from './product/ProductInfo';
import { ProductPricing } from './product/ProductPricing';
import { ProductActions } from './product/ProductActions';

export default function ProductDetail() {
  const { id } = useParams();
  const remote = useRemote(`/products/${id}`);
  const { user } = useApp();
  if (remote.loading || remote.error || !remote.data) {
    return <div className="container section-pad"><LoadState remote={remote} /></div>;
  }
  const product = remote.data;
  return <div className="container detail-page">
    <div className="breadcrumb"><Link to="/catalog" data-testid="detail-catalog-crumb">Catalog</Link>
      <ChevronRight size={12} /><span>{product.sku}</span></div>
    <div className="detail-layout">
      <ProductMedia product={product} />
      <div className="detail-info">
        <ProductInfo product={product} />
        <ProductPricing product={product} user={user} />
        <ProductActions product={product} user={user} />
      </div>
    </div>
    <ProductSpecifications product={product} />
    <div className="detail-bottom-link"><LinkButton to="/catalog" id="back-to-catalog" secondary>
      Continue sourcing<ArrowUpRight size={16} />
    </LinkButton></div>
  </div>;
}